export const CAR_ZONES = [
  { key: "pare_choc_av", x: 62, y: 14, w: 116, h: 24, rx: 12 },
  { key: "capot", x: 74, y: 42, w: 92, h: 104, rx: 14 },
  { key: "aile_av_g", x: 40, y: 42, w: 30, h: 104, rx: 12 },
  { key: "aile_av_d", x: 170, y: 42, w: 30, h: 104, rx: 12 },
  { key: "porte_av_g", x: 40, y: 150, w: 30, h: 92, rx: 6 },
  { key: "porte_av_d", x: 170, y: 150, w: 30, h: 92, rx: 6 },
  { key: "toit", x: 80, y: 186, w: 80, h: 110, rx: 12 },
  { key: "porte_ar_g", x: 40, y: 246, w: 30, h: 88, rx: 6 },
  { key: "porte_ar_d", x: 170, y: 246, w: 30, h: 88, rx: 6 },
  { key: "aile_ar_g", x: 40, y: 338, w: 30, h: 90, rx: 12 },
  { key: "aile_ar_d", x: 170, y: 338, w: 30, h: 90, rx: 12 },
  { key: "coffre", x: 80, y: 334, w: 80, h: 94, rx: 12 },
  { key: "pare_choc_ar", x: 62, y: 432, w: 116, h: 24, rx: 12 },
];

export const ZONE_LABELS = {
  capot: "Capot", toit: "Toit", coffre: "Coffre / Hayon", aile_av_g: "Aile AV gauche", aile_av_d: "Aile AV droite",
  porte_av_g: "Porte AV gauche", porte_av_d: "Porte AV droite", porte_ar_g: "Porte AR gauche", porte_ar_d: "Porte AR droite",
  aile_ar_g: "Aile AR gauche", aile_ar_d: "Aile AR droite", pare_choc_av: "Pare-choc AV", pare_choc_ar: "Pare-choc AR",
  jantes: "Jantes", vitrage: "Vitrage / pare-brise", interieur: "Intérieur",
};

const SHORT = { capot: "Capot", toit: "Toit", coffre: "Coffre", pare_choc_av: "Pare-choc AV", pare_choc_ar: "Pare-choc AR" };
const shortLabel = (k) => SHORT[k] || (ZONE_LABELS[k] || k).replace("gauche", "G").replace("droite", "D");
const WHEELS = [[22, 70], [210, 70], [22, 360], [210, 360]];
const COLORS = {
  selected: ["#DBEAFE", "#2563EB"], measured: ["#D1FAE5", "#10B981"], defect: ["#FEF3C7", "#F59E0B"], empty: ["#F8FAFC", "#94A3B8"],
};

function Marker({ x, y, n, onClick, testid }) {
  return (
    <g data-testid={testid} onClick={(e) => { e.stopPropagation(); onClick(); }} className="cursor-pointer">
      <circle cx={x} cy={y} r="9" fill="#DC2626" stroke="#fff" strokeWidth="1.5" />
      <text x={x} y={y + 3.5} textAnchor="middle" fontSize="10" fontWeight="700" fill="#fff" pointerEvents="none">{n}</text>
    </g>
  );
}

/* ===================== SCHÉMA INTÉRIEUR (vue de dessus) ===================== */
export const INTERIOR_ZONES = [
  { key: "int_tableau_bord", label: "Tableau de bord", rects: [[44, 30, 152, 40]] },
  { key: "int_tapis_conducteur", label: "Tapis cond.", rects: [[52, 98, 56, 24]] },
  { key: "int_tapis_passager", label: "Tapis pass.", rects: [[132, 76, 56, 46]] },
  { key: "int_siege_conducteur", label: "Siège cond.", rects: [[52, 140, 56, 66]] },
  { key: "int_siege_passager", label: "Siège pass.", rects: [[132, 140, 56, 66]] },
  { key: "int_appuie_tetes", label: "Appuie-têtes", rects: [[64, 126, 32, 12], [144, 126, 32, 12], [64, 302, 32, 10], [144, 302, 32, 10]] },
  { key: "int_console", label: "Console", rects: [[112, 74, 16, 132]] },
  { key: "int_accoudoir", label: "Accoud.", rects: [[112, 208, 16, 28]] },
  { key: "int_tapis_arriere", label: "Tapis AR", rects: [[52, 212, 56, 24], [132, 212, 56, 24]] },
  { key: "int_banquette", label: "Banquette arrière", rects: [[52, 240, 136, 60]] },
  { key: "int_porte_av_g", label: "Porte AV G", rects: [[32, 96, 16, 112]] },
  { key: "int_porte_av_d", label: "Porte AV D", rects: [[192, 96, 16, 112]] },
  { key: "int_porte_ar_g", label: "Porte AR G", rects: [[32, 212, 16, 92]] },
  { key: "int_porte_ar_d", label: "Porte AR D", rects: [[192, 212, 16, 92]] },
  { key: "int_plage_arriere", label: "Plage arrière", rects: [[52, 316, 136, 18]] },
  { key: "int_coffre", label: "Coffre", rects: [[52, 338, 136, 96]] },
];
export const INTERIOR_EXTRA = [
  ["int_volant", "Volant"], ["int_dossiers_assises", "Dossiers et assises"], ["int_moquettes", "Moquettes"], ["int_ciel_toit", "Ciel de toit"],
  ["int_montants", "Montants intérieurs"], ["int_ceintures", "Ceintures de sécurité"], ["int_vitres", "Vitres intérieures"], ["int_garnitures", "Garnitures et plastiques"],
];
INTERIOR_ZONES.forEach((z) => { ZONE_LABELS[z.key] = { int_siege_conducteur: "Siège conducteur", int_siege_passager: "Siège passager", int_tapis_conducteur: "Tapis conducteur", int_tapis_passager: "Tapis passager", int_tapis_arriere: "Tapis arrière", int_console: "Console centrale", int_accoudoir: "Accoudoir central", int_porte_av_g: "Panneau porte AV gauche", int_porte_av_d: "Panneau porte AV droit", int_porte_ar_g: "Panneau porte AR gauche", int_porte_ar_d: "Panneau porte AR droit" }[z.key] || z.label; });
INTERIOR_EXTRA.forEach(([k, l]) => { ZONE_LABELS[k] = l; });

export function InteriorDiagram({ zoneInfo, onPick, markers = {}, onMarker }) {
  const wheel = zoneInfo("int_volant").state;
  return (
    <svg viewBox="0 0 240 470" className="w-full max-w-[340px] mx-auto block select-none" data-testid="interior-car-diagram" role="img" aria-label="Schéma intérieur vue de dessus">
      <rect x="24" y="14" width="192" height="436" rx="56" fill="#0F172A" opacity="0.06" />
      {INTERIOR_ZONES.map((z) => {
        const { state = "empty" } = zoneInfo(z.key);
        const [fill, stroke] = COLORS[state] || COLORS.empty;
        const [x, y, w, h] = z.rects[0];
        const vertical = h > w * 2 && w < 30;
        const cx = x + w / 2; const cy = y + h / 2;
        return (
          <g key={z.key} data-testid={`int-svg-${z.key}`} data-state={state} onClick={() => onPick(z.key)} className="cursor-pointer" role="button" aria-label={ZONE_LABELS[z.key]}>
            {z.rects.map(([rx, ry, rw, rh], i) => <rect key={i} x={rx} y={ry} width={rw} height={rh} rx="5" fill={fill} stroke={stroke} strokeWidth={state === "selected" ? 3 : 1.5} style={{ transition: "fill .2s, stroke .2s" }} />)}
            {h >= 18 && <text transform={vertical ? `rotate(-90 ${cx} ${cy})` : undefined} x={cx} y={cy + 3} textAnchor="middle" fontSize="7.5" fontWeight="600" fill="#475569" pointerEvents="none">{z.label}</text>}
          </g>
        );
      })}
      <g data-testid="int-svg-int_volant" data-state={wheel} onClick={() => onPick("int_volant")} className="cursor-pointer">
        <circle cx="80" cy="82" r="15" fill={COLORS[wheel][0]} stroke={wheel === "empty" ? "#334155" : COLORS[wheel][1]} strokeWidth="3" />
        <circle cx="80" cy="82" r="4" fill="#334155" />
      </g>
      {Object.entries(markers).filter(([, n]) => n > 0).map(([k, n]) => {
        const z = INTERIOR_ZONES.find((x) => x.key === k);
        const pos = z ? [z.rects[0][0] + z.rects[0][2] - 4, z.rects[0][1] + 5] : k === "int_volant" ? [94, 70] : null;
        return pos ? <Marker key={k} x={pos[0]} y={pos[1]} n={n} onClick={() => onMarker && onMarker(k)} testid={`int-svg-marker-${k}`} /> : null;
      })}
      <text x="120" y="10" textAnchor="middle" fontSize="6" fill="#94A3B8">AVANT</text>
      <text x="120" y="462" textAnchor="middle" fontSize="6" fill="#94A3B8">ARRIÈRE</text>
    </svg>
  );
}

/* zoneInfo(key) -> { state: empty|measured|defect|selected, lines: [{text, color, testid}] }
   markers: { key: count } ; extended: rend jantes + vitrage cliquables (état des lieux). */
export default function CarDiagram({ zoneInfo, onPick, markers = {}, onMarker, extended = false, testid = "ptg-car-diagram", zonePrefix = "ptg-svg" }) {
  const wheelState = zoneInfo("jantes").state;
  const glassState = zoneInfo("vitrage").state;
  return (
    <svg viewBox="0 0 240 470" className="w-full max-w-[340px] mx-auto block select-none" data-testid={testid} role="img" aria-label="Schéma voiture vue de dessus">
      <rect x="30" y="8" width="180" height="454" rx="60" fill="#0F172A" opacity="0.06" />
      <g data-testid={`${zonePrefix}-jantes`} onClick={extended ? () => onPick("jantes") : undefined} className={extended ? "cursor-pointer" : ""}>
        {WHEELS.map(([x, y], i) => <rect key={i} x={x} y={y} width="8" height="46" rx="3" fill={extended && wheelState !== "empty" ? COLORS[wheelState][1] : "#334155"} />)}
        {extended && WHEELS.map(([x, y], i) => <rect key={`h${i}`} x={x - 8} y={y - 4} width="24" height="54" fill="transparent" />)}
      </g>
      <g data-testid={`${zonePrefix}-vitrage`} onClick={extended ? () => onPick("vitrage") : undefined} className={extended ? "cursor-pointer" : ""}>
        <path d="M80 150 Q120 140 160 150 L156 182 Q120 176 84 182 Z" fill={extended && glassState !== "empty" ? COLORS[glassState][0] : "#BAE6FD"} stroke={extended && glassState !== "empty" ? COLORS[glassState][1] : "#7DD3FC"} />
        <path d="M84 300 Q120 306 156 300 L160 330 Q120 338 80 330 Z" fill={extended && glassState !== "empty" ? COLORS[glassState][0] : "#BAE6FD"} stroke={extended && glassState !== "empty" ? COLORS[glassState][1] : "#7DD3FC"} />
      </g>
      <path d="M74 150 L76 242 M166 150 L164 242" stroke="#CBD5E1" strokeWidth="1" />
      {CAR_ZONES.map((z) => {
        const { state = "empty", lines = [] } = zoneInfo(z.key);
        const [fill, stroke] = COLORS[state] || COLORS.empty;
        const vertical = z.w < 40;
        const cx = z.x + z.w / 2; const cy = z.y + z.h / 2;
        const off = lines.length ? -6 : 3;
        return (
          <g key={z.key} data-testid={`${zonePrefix}-${z.key}`} data-state={state} onClick={() => onPick(z.key)} className="cursor-pointer" role="button" aria-label={ZONE_LABELS[z.key]}>
            <rect x={z.x} y={z.y} width={z.w} height={z.h} rx={z.rx} fill={fill} stroke={stroke} strokeWidth={state === "selected" ? 3 : 1.5} style={{ transition: "fill .2s, stroke .2s" }} />
            <g transform={vertical ? `rotate(-90 ${cx} ${cy})` : undefined} pointerEvents="none">
              <text x={cx} y={cy + off} textAnchor="middle" fontSize="8.5" fontWeight="600" fill="#475569">{shortLabel(z.key)}</text>
              {lines.map((l, i) => <text key={i} data-testid={l.testid} x={cx} y={cy + 6 + i * 11} textAnchor="middle" fontSize={i ? 8.5 : 10} fontWeight="700" fill={l.color}>{l.text}</text>)}
            </g>
          </g>
        );
      })}
      {Object.entries(markers).filter(([, n]) => n > 0).map(([k, n]) => {
        const z = CAR_ZONES.find((x) => x.key === k);
        const pos = z ? [z.x + z.w - 4, z.y + 6] : k === "jantes" ? [26, 66] : k === "vitrage" ? [160, 150] : null;
        return pos ? <Marker key={k} x={pos[0]} y={pos[1]} n={n} onClick={() => onMarker && onMarker(k)} testid={`${zonePrefix}-marker-${k}`} /> : null;
      })}
      <text x="120" y="6" textAnchor="middle" fontSize="6" fill="#94A3B8">AVANT</text>
      <text x="120" y="468" textAnchor="middle" fontSize="6" fill="#94A3B8">ARRIÈRE</text>
    </svg>
  );
}
